import type { Fallacy } from "./types";
import { createStory } from "./types";

export const appealToTradition: Fallacy = {
    id: "appeal-to-tradition",
    name: "Appeal to Tradition",
    emoji: "📜",
    category: "Argumen Lemah",
    description:
      "Menganggap sesuatu benar karena **sudah dilakukan sejak dulu**. 'Dari dulu juga gini.'",
    tldr: "'Dari dulu gini kok' bukan argumen. Dulu orang juga percaya bumi datar.",
    detail:
      "Appeal to Tradition adalah kesalahan logika di mana seseorang berargumen bahwa sesuatu pasti benar atau harus dipertahankan karena **sudah menjadi tradisi atau kebiasaan lama**. Padahal, **lamanya sebuah praktik tidak menjamin kebenarannya**.\n\nKenapa ini fallacy? Karena dunia berubah dan pengetahuan bertambah. Apa yang masuk akal 100 tahun lalu bisa jadi tidak relevan atau berbahaya hari ini. Tradisi perlu dievaluasi, bukan diterima secara buta.\n\nCara melawan: \"Memang sudah lama dilakukan, tapi apakah masih relevan? Apakah ada cara yang lebih baik berdasarkan pengetahuan sekarang?\"",
    story: createStory("Appeal to Tradition", "📜", {
      hook: {
        title: "\"Dari dulu juga gini kok!\"",
        body: "Dulu orang juga percaya bumi datar. **Lama bukan berarti bener.**",
      },
      convo: {
        claim: "Dari dulu rapat ya tatap muka. **Gak usah ubah yang udah jalan.** Emang gini caranya!",
        response: "\"Udah lama\" bukan alasan. Yang penting **apakah cara itu masih efektif atau ada yang lebih baik.**",
      },
      reveal: {
        body: "Nganggep sesuatu **pasti benar karena sudah jadi kebiasaan lama**. Padahal dunia berubah, pengetahuan bertambah.",
      },
      insight: {
        title: "Inti masalahnya?",
        body: "\"Udah lama\" bukan alasan. Dulu orang juga percaya bumi datar. Kebiasaan perlu **dievaluasi**, bukan diterima mentah-mentah.",
      },
      engagement: {
        title: "Tradisi apa yang menurutmu paling gak relevan tapi masih dipaksa jalan?",
        body: "Rapat tatap muka atau ranking sekolah? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-nature", "appeal-to-authority", "bandwagon"],
  };
